// extracted by mini-css-extract-plugin
module.exports = {"feedbackFrame":"feedbackView_feedbackFrame__3359J","para":"feedbackView_para__2R05f typography_bodyText__3tX_a"};